export default {
  editPermissions: 'Set permissions',
  safePassword: {
    summary: 'Copy initial password',
    details: 'The following initial password is shown only once. Please make sure to note it down and share it with the new user. Upon first login, the user will be prompted to set a permanent password.',
  },
  title: 'Create new user',
};
